import { useEffect, useState } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';

import { getLocationParams } from '@core/js/utils/url.util';
import { useUserSelector } from '@core/js/store/hooks';
import { useEffectOnce } from '@core/js/hooks/useEffectOnce';
import { userSetAttributesAction } from '@core/js/hooks/user/store/actions';
import { useIsUserVerified } from '@interlayer/js/app/hooks/user/hooks/useIsUserVerified';
import { PLAYER_TAG_IDV_CHECKED } from '@interlayer/js/components/system/Page/buzz/constants';

import { JUMIO_STEPS } from '../constants';

export const useSetStatusAfterLoading = ({ setCurrentStep, timeout, setVerificationPassed, handlerAfterPassed, isSimple }) => {
    const dispatch = useDispatch();
    const { isNative } = getLocationParams();
    const isUserVerified = useIsUserVerified();
    const [isCheckedStatus, setIsCheckedStatus] = useState(false);
    const { jumioStep, allPlayerTags: playerTags } = useUserSelector(pick(['jumioStep', 'allPlayerTags']));

    useEffect(() => {
        if (!isCheckedStatus) {
            return;
        }

        if (isSimple) {
            handlerAfterPassed();

            return;
        }

        if (!isUserVerified) {
            setCurrentStep(JUMIO_STEPS[playerTags?.[PLAYER_TAG_IDV_CHECKED] ? 'error' : 'takeMeHome']);
        } else {
            setCurrentStep(JUMIO_STEPS.passed);
            dispatch(userSetAttributesAction({ idvTriggered: false }));
            dispatcher.dispatch('id_verification:passed');

            if (isNative === '1') {
                setVerificationPassed(true);

                handlerAfterPassed();
            }
        }
    }, [
        isSimple,
        playerTags,
        dispatch,
        handlerAfterPassed,
        isCheckedStatus,
        isNative,
        isUserVerified,
        setCurrentStep,
        setVerificationPassed
    ]);

    useEffect(() => {
        if (isUserVerified || playerTags?.[PLAYER_TAG_IDV_CHECKED]) {
            setIsCheckedStatus(true);
        }
    }, [isUserVerified, playerTags]);

    useEffectOnce(() => {
        setTimeout(() => setIsCheckedStatus(true), timeout);
    }, [jumioStep], () => jumioStep === 'loading' || isSimple);
};
